import React, { useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { Add } from "@mui/icons-material";
import { Autocomplete, Button, TextField } from "@mui/material";

import { PageHeader } from "../../components/PageHeader";
import { PageSection } from "../../components/PageSection";
import { useModal } from "../../hooks/useModal";
import { useDataSets } from "../dashboard-view/api/useDatasets";

import { CreateSubstitutionModal } from "./components/CreateSubstitutionModal";
import { SubstitutionsTable } from "./components/SubstitutionsTable";

export function SubstitutionsView() {
  const { open, handleOpen, handleClose } = useModal();
  const { formatMessage } = useIntl();
  const { datasets } = useDataSets();
  const [datasetId, setDatasetId] = useState<number | undefined>(undefined);
  const options = useMemo(
    () =>
      Array.isArray(datasets?.Datasets)
        ? datasets?.Datasets.map(d => ({ id: d.Id!, label: d.Name! }))
        : [],
    [datasets],
  );

  return (
    <div>
      <PageHeader
        text={formatMessage({
          id: "SUBSTITUTIONS.TITLE",
          defaultMessage: "CAFS substitutions",
          description: "Substitutions page title",
        })}
        rightPart={
          <div className="flex gap-2">
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              onClick={handleOpen}>
              <FormattedMessage
                id="SUBSTITUTIONS.ADD_NEW_BTN"
                description="Add new substitution button"
                defaultMessage="ADD NEW ROW"
              />
            </Button>
          </div>
        }
      />

      <PageSection>
        <div className="mb-6 max-w-md">
          <Autocomplete
            size="small"
            options={options}
            value={options.find(o => o.id === datasetId) ?? null}
            onChange={(_, value) => setDatasetId(value?.id)}
            renderInput={params => (
              <TextField
                {...params}
                label={formatMessage({
                  id: "APP.DATASET",
                  defaultMessage: "Dataset",
                })}
              />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
          />
        </div>

        <SubstitutionsTable datasetId={datasetId} />
      </PageSection>

      <CreateSubstitutionModal open={open} onClose={handleClose} />
    </div>
  );
}
